/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable quotes */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/sort-comp */
/* eslint-disable react/button-has-type */
/* eslint-disable no-return-assign */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-loop-func */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import React from "react";
import { connect } from "react-redux";
import moment, { relativeTimeThreshold } from "moment";
import { injectStripe } from "react-stripe-elements";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import publicIp from "public-ip";
import PlaidLink from "react-plaid-link";
import { css } from "emotion";
import { SyncLoader } from "react-spinners";
// import Promise from 'promise-polyfill';
import aaBlue from "./images/AA_blue.png";
import applePay from "./images/apple-pay.png";
import googlePay from "./images/google-pay.png";
import SimpleModal from "./simpleModal";
import PaymentSuccess from "./images/payment-success.png";
import PayWithCard from "./components/PayWithCard";
import PayWithBank from "./components/PayWithBank";
import FAQEnglish from "./components/faqs/FAQEnglish";
import FAQSpanish from "./components/faqs/FAQSpanish";
import FAQFrench from "./components/faqs/FAQFrench";
import MemberInfo from "./components/MemberInfo";

class Form extends React.Component {
  memberList = [
    {
      aaid: "",
      name: "",
      fromDate: "",
      thruDate: ""
    }
  ];

  constructor(props) {
    super(props);

    this.buttonRef = React.createRef();

    this.state = {
      invoiceNumberValue: "",
      enablePaymentButton: true,
      checkForMember: false,
      alertSize: { height: "40%", width: "50%" },
      membershipRate: "",
      salesTax: "",
      plaidEnvironment: "",
      loading: false,
      stripeCustomerId: "",
      authLetterApiKey: "",
      memberNotFound: false,
      processing: false,
      confirmationNumber: "",
      refresh: true,
      show: false,
      validated: false,
      individual: "",
      to: "",
      alertMessage: "Your payment was processed",
      alertMessage2: "",
      stripeCancelButton: "",
      radioPayWithCard: "",
      radioPayWithACH: "",
      labelStripeCard: "",
      aaMembership: "",
      cbToS: "",
      achAuthApiUrl: "",
      stripeApiUrl: "",
      pageName: "",
      email: "",
      formErrors: { zipCode: "", achChecked: "", email: "" },
      achTouchedCount: 0,
      lookupMemberApiUrl: "",
      fieldValid: false,
      zipCodeValid: false,
      formValid: false,
      cardChecked: true,
      bankChecked: false,
      paymentButton: "",
      ipAddress: "",
      aanumber: "",
      selectedLanguage: "english",
      accountNumber: "",
      searchButton: "",
      searchMessage: "",
      fromDate: "",
      thruDate: "",
      routingNumber: "",
      basePrice: "",
      achChecked: false,
      labelNameOnCard: "",
      country: "united states",
      zipCode: "",
      disableSubmit: false,
      checked: [],
      xapikey: "",
      plaidApiKey: "",
      plaidApiUrl: "",
      buttonColor: "#1C407B1",
      creditCardEntered: false,
      invalidFontColorEmail: "",
      invalidFontColorZip: "",
      customerData: [],
      openPlaidInterface: false,
      labelCountry: "",
      personObj: {},
      paymentRequest: {},
      clientSecret: "",
      applePayment: false,
      googlePayment: false,
      invoiceTotal: "",
      taxCalculated: "",
      invoiceNumber: "",
      salesTaxPercentage: "",
      customerState: "",
      uiBaseAmount: "",
      baseAmount: "0",
    };
  }

  async componentDidMount() {
    await this.getApiKey();
    await this.handleGetaaId();
    const { customerData, aanumber } = this.state;
    await this.getIPAddress();
    aanumber && (await this.handleGetMemberInfo(aanumber));
    await this.updateCheckedItems(customerData);
    await this.handleSettingUpPaymentRequest();
    this.getBaseRate();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.data.language !== this.props.data.language) {
      await this.setInitialLanguage();
    }
  }

  getIPAddress = async () => {
    const ipAddress = await publicIp.v4();
    this.setState({ ipAddress });
  };

  getApiKey = () => {
    this.setState({
      xapikey: process.env.REACT_APP_CHARGEAPIKEY,
      lambdaAPIKey: process.env.REACT_APP_LAMBDAAPIKEY,
      plaidApiKey: process.env.REACT_APP_PLAIDAPIKEY,
      plaidApiUrl: process.env.REACT_APP_PLAIDURL,
      plaidEnvironment: process.env.REACT_APP_PLAIDENVIRONMENT,
      achAuthApiUrl: process.env.REACT_APP_ACHLETTER,
      lookupMemberApiUrl: process.env.REACT_APP_LOOKUPMEMBERNUMBER,
      getPaymentIntent: process.env.REACT_APP_GETPAYMENTINTENT,
      stripeApiUrl: process.env.REACT_APP_STRIPEURL,
      stripeGetInvoices: process.env.REACT_APP_GETINVOICES,
      stripeGetPrice: process.env.REACT_APP_GETPRICE,
      aaCustomerLookup: process.env.REACT_APP_AACUSTOMERLOOKUP
    });
  };

  setInitialLanguage = () => {
    Object.keys(this.props.data.language.language[0]).forEach((key) => {
      if (key === "english") {
        Object.keys(this.props.data.language.language[0][key]).forEach((lang) => {
          this.setState({ [lang]: this.props.data.language.language[0][key][lang] });
        });
      }
    });
  };

  getBaseRate = async () => {
    const {
      stripeGetPrice,
      lambdaAPIKey
    } = this.state;

    const headers = {
      "x-api-key": lambdaAPIKey
    };

    await axios
      .get(`${stripeGetPrice}`, { headers })
      .then((priceRes) => {
        this.setState({ uiBaseAmount: priceRes.data.uiBaseAmount, baseAmount: priceRes.data.baseAmount });
      })
      .catch((ex) => {
        this.setState({ uiBaseAmount: this.state.basePrice });
        console.error("The following error occurred: ", ex);
      });
  }

  changeText = (selectLanguage) => {
    this.props.data.language.language.forEach((language) => {
      Object.keys(language).forEach((key) => {
        if (key === selectLanguage) {
          Object.keys(language[key]).forEach((k) => {
            this.setState({
              [k]: language[key][k],
              selectedLanguage: selectLanguage
            });
          });
        }
      });
    });
  };

  handleClearFields = (e) => {
    const { creditCardEntered } = this.state;
    if (creditCardEntered) {
      e.preventDefault();
      window.history.replaceState({}, document.title, "/");
      window.location.reload();
    }
  };

  isValidPostalCode(country, postalCode) {
    const countryLower = country.toLowerCase();

    if (countryLower === "united states") {
      return !!postalCode.match(/^[0-9]{5}$|^[0-9]{9}$|^[0-9]{5}-[0-9]{4}$/);
    }
    if (countryLower === "canada") {
      return !!postalCode.match(
        /^[a-zA-Z][0-9][a-zA-Z][0-9][a-zA-Z][0-9]|^[a-zA-Z][0-9][a-zA-Z] [0-9][a-zA-Z][0-9]$/
      );
    }
    if (countryLower === "mexico") {
      return !!postalCode.match(/^[0-9]{5}$/);
    }

    return !!postalCode;
  }

  validateField(fieldName, value) {
    const { country, formErrors, zipCode, fieldValid } = this.state;
    let emailValid = false;
    const fieldValidationErrors = formErrors;
    let { zipCodeValid } = this.state;

    switch (fieldName) {
      case "country":
      case "zipCode":
        // we need to validate zip code both when the country changes and when the zip code changes
        // when the country changes, we will validate the new value with the zipCode from state
        // when the zip code changes, we will validate the new value with the country from state
        const countryToValidate = fieldName === "country" ? value : country;
        const zipToValidate = fieldName === "country" ? zipCode : value;

        zipCodeValid = this.isValidPostalCode(countryToValidate, zipToValidate);

        fieldValidationErrors.zipCode = zipCodeValid
          ? ""
          : "Zipcode is not valid";

        zipCodeValid
          ? this.setState({ invalidFontColorZip: "" })
          : this.setState({ invalidFontColorZip: "invalid-value" });

        break;
      case "email":
        emailValid = !!value.match(
          /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
        );
        fieldValidationErrors.email = emailValid ? "" : "Email is not valid";
        fieldValid
          ? this.setState({ invalidFontColorName: "" })
          : this.setState({ invalidFontColorName: "invalid-value" });
        break;
      default:
        break;
    }

    this.setState(
      {
        formErrors: fieldValidationErrors,
        zipCodeValid
      },
      () => this.validateForm()
    );
  }

  setValidateColors(fieldName) {
    const { zipCodeValid } = this.state;

    switch (fieldName) {
      case "zipCode":
        zipCodeValid
          ? this.setState({ invalidFontColorZip: "" })
          : this.setState({ invalidFontColorZip: "invalid-value" });
        break;
      default:
        break;
    }
  }

  validateForm() {
    const { zipCodeValid } = this.state;
    this.setState({
      formValid: zipCodeValid
    });
  }

  validateChecked = (e) => {
    const { formErrors, achTouchedCount } = this.state;
    const formErrs = formErrors;
    if (e.target.checked) {
      formErrs.achChecked = "";
    } else {
      formErrs.achChecked = "You must agree to Terms of Service to continue!";
    }
    this.setState(
      {
        achChecked: e.target.checked,
        formErrors: formErrs,
        achTouchedCount: achTouchedCount + 1
      },
      () => this.handleEnablePaymentButton()
    );
  };

  handleStateChange = async (e) => {
    const { aanumber } = this.state;
    const { name, value } = e.target;

    this.setState({ [name]: value });

    if (name === "aanumber" && aanumber.length === 9) {
      this.setState({ checkForMember: true });
    }

    if (name === "aanumber" && value.length !== 9) {
      this.setState({
        formValid: false,
        name: "",
        fromDate: "",
        to: "",
        checkForMember: false
      });
    }

    await this.validateField(name, value);

    await this.handleEnablePaymentButton();
  };

  handleInvalidFields = (e) => {
    const { name } = e.target;
    this.setValidateColors(name);
  };

  handleCreditCardEntered = async (valid) => {
    if (valid) await this.setState({ creditCardEntered: true });
    else await this.setState({ creditCardEntered: false });

    this.handleEnablePaymentButton();
  };

  handleChangeEmail = (e) => {
    this.setState({ email: e.target.value });
  };

  handleMemberNumberLookup = async (aaId) => {
    const {
      lookupMemberApiUrl,
      stripeGetInvoices,
      lambdaAPIKey,
      errorAAIDNotFound,
      errorNoEmailFound1,
      errorNoEmailFound2
    } = this.state;

    const headers = {
      "x-api-key": lambdaAPIKey
    };

    this.setState({ loading: true, personObj: {} });

    await axios
      .get(`${lookupMemberApiUrl}?aaId=${aaId}`, { headers })
      .then(async (resp) => {
        let personRes = resp.data;

        if (personRes === 'The email is not present in the data') {
          this.setState({
            show: true,
            aanumber: "",
            name: "",
            loading: false,
            alertMessage: errorNoEmailFound1,
            alertMessage2: errorNoEmailFound2,
            alertSize: { width: "40%", height: "40%" }
          });
          return;
        }

        if (Object.keys(personRes).includes("language")) {
          if (personRes.language.includes("en")) personRes.language = "English";
          if (personRes.language.includes("fr")) personRes.language = "French";
          if (personRes.language.includes("es")) personRes.language = "Spanish";
        } else {
          personRes.language = "English";
        }

        personRes.personId = aaId;

        this.setState({ personObj: personRes });

        axios
          .get(`${stripeGetInvoices}?aaNumber=${aaId}`, { headers })
          .then((invRes) => {
            this.setState({ invoiceNumberValue: invRes.data.invoiceNumber });
          })
          .catch((ex) => {
            console.error("The following error occurred: ", ex);
          });

        await this.handleInvoiceLookup(aaId);

        if (
          Object.keys(resp.data).length === 0 &&
          resp.data.constructor === Object
        ) {
          this.setState({
            show: true,
            name: "",
            alertMessage: errorAAIDNotFound,
            alertSize: { width: "30%", height: "40%" }
          });
        } else if (resp.data && !resp.data.email.length) {
          this.setState({
            show: true,
            name: "",
            alertMessage: errorNoEmailFound1,
            alertMessage2: errorNoEmailFound2,
            alertSize: { width: "40%", height: "40%" }
          });
        } else {
          this.setState({ validated: true });
        }
        if (Object.getOwnPropertyNames(resp.data).length === 0) {
          this.setState({ memberNotFound: true });
        } else {
          this.setState({ memberNotFound: false });
        }

        if (
          resp.status === 200 &&
          Object.getOwnPropertyNames(resp.data).length > 0
        ) {
          const name = `*****${resp.data.lastName.slice(-2)}`;

          let fromDate = new Date();
          if (
            resp.data.membershipExpDate &&
            resp.data.membershipExpDate !== undefined
          ) {
            if (new Date(resp.data.membershipExpDate) >= new Date()) {
              fromDate = resp.data.membershipExpDate;
            }
          }

          this.setState({ name, fromDate }, () => {
            this.handleEnablePaymentButton();
          });
        } else {
          this.setState({ memberNotFound: true });
        }
      })
      .catch((ex) => {
        this.setState({
          memberNotFound: true,
          loading: false,
          show: true,
          alertMessage:
            "This number was not found.  Please check your number and try again"
        });
      });
  };

  handleMemberLookup = async (e) => {
    const { aanumber } = this.state;
    this.getBaseRate();
    e.preventDefault();
    this.setState({ loading: true });

    await this.handleMemberNumberLookup(aanumber);
  };

  handleInvoiceLookup = async (aanumber) => {
    const res = await this.handleGetCustomerStripeId(aanumber);
    if (res[2] === 200) {
      this.setState({ loading: false, invoiceNumberValue: res[3] });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { bankChecked, invoiceTotal } = this.state;
    this.setState({ enablePaymentButton: true });
    if (bankChecked) {
      this.handleOpenPlaid();
      return 0;
    }

    let successfulPayment = false;
    const { name, aanumber, checked, zipCode } = this.state;
    const { stripe } = this.props;

    try {
      // Despite what airbnb thinks, I need this await to make sure I get a token returned.
      const { token } = await stripe.createToken({
        name,
        aaId: aanumber,
        address_zip: zipCode
      });

      this.setState({ loading: true });

      const { stripeApiUrl, xapikey, personObj, baseAmount } = this.state;

      const amount = invoiceTotal ? parseInt(invoiceTotal.replace('.', ''), 10) : parseInt(baseAmount);
      const aaId = aanumber;

      const headers = { "x-api-key": xapikey };

      const body = { token: token.id, amount, aaId, payer: personObj };

      await axios(stripeApiUrl, { method: "POST", headers, data: body })
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              confirmationNumber: response.data.id,
              alertMessage: "Your payment was processed"
            });
            successfulPayment = true;
          } else {
            this.setState({
              confirmationNumber: "",
              show: true,
              alertMessage: "There was an issue processing your payment"
            });
          }
        })
        .catch((error) => {
          this.setState({
            show: true,
            confirmationNumber: "",
            alertMessage: "There was an issue processing your payment"
          });
          console.error("The following error was recorded: ", error);
        });
    } catch (err) {
      this.setState({
        show: true,
        confirmationNumber: "",
        alertMessage: "There was an issue processing your payment"
      });
      console.error("The following error was recorded: ", err);
    } finally {
      this.setState({ loading: false });
    }

    if (successfulPayment === true) {
      this.setState({ show: true, name: "", email: "", pageName: "" });
    }

    this.setState({ enablePaymentButton: false });
  };

  handleGetaaId = async () => {
    const searchParams = new URLSearchParams(window.location.search);
    this.getBaseRate();

    if (searchParams.get("aaId")) {
      this.setState({ aanumber: searchParams.get("aaId") });

      // This is temporarily here until I am actually getting the data
      this.memberList = this.memberList.filter((cust) =>
        [...searchParams.get("aaId").split(",")].includes(cust.aaid)
      );
    }
  };

  handleCheckClicked = (e) => {
    if (e.target.name === "checkPayWithCard") {
      this.setState({ cardChecked: true, bankChecked: false },
        () => this.handleEnablePaymentButton()
      );
    } else {
      this.setState({ cardChecked: false, bankChecked: true },
        () => this.handleEnablePaymentButton()
      );
    }
  };

  handleCancelledPayment = (e) => {
    e.preventDefault();
    window.history.replaceState({}, document.title, "/");
    window.location.reload();
  };

  updateCheckedItems = (arr) => {
    this.setState({ checked: arr.map((a) => a.aaid) });
  };

  handleDisableButton = (val) => {
    val > 0
      ? this.setState({ disableSubmit: false })
      : this.setState({ disableSubmit: true });
  };

  handleGetCustomerStripeId = async (aaId) => {
    const { aaCustomerLookup, lambdaAPIKey } = this.state;
    const url = `${aaCustomerLookup}?aaNumber=${aaId}`;

    const headers = {
      "x-api-key": lambdaAPIKey
    };

    let customerState = '';
    let invoiceTotal = '0.0';
    let statusCode = 200;
    let invoiceNumber = '';

    await axios({ method: "get", url, headers }).then((resp) => {
      statusCode = resp.status;

      if (statusCode === 200 && Object.getOwnPropertyNames(resp.data).length) {
        customerState = resp.data.customerState;
        invoiceTotal = resp.data.invoiceTotal;
        invoiceNumber = resp.data.invoiceNumber;
        this.setState({
          stripeCustomerId: resp.data.stripeId,
          invoiceTotal: resp.data.invoiceTotal,
          taxCalculated: resp.data.taxCalculated,
          invoiceNumberValue: resp.data.invoiceNumber,
          salesTaxPercentage: resp.data.salesTaxPercentage,
          customerState: resp.data.customerState
        });
      }
    });
    return [customerState, invoiceTotal, statusCode, invoiceNumber];
  };

  handleGetMemberInfo = async (aaId) => {
    this.setState({ loading: true });

    await this.handleMemberNumberLookup(aaId);

    await this.handleGetCustomerStripeId(aaId);
    await this.handleEnablePaymentButton();

    this.setState({ loading: false });
  };

  handleCreateAuthLetter = async (routingNumber, accountNumber, amt) => {
    const { aanumber, ipAddress, lambdaAPIKey, achAuthApiUrl } = this.state;

    const headers = {
      "x-api-key": lambdaAPIKey
    };

    await axios(achAuthApiUrl, {
      method: "POST",
      headers,
      data: {
        personId: aanumber,
        type: "276",
        esigned: "true",
        esignedDate: moment().format("MM/DD/YYYY"),
        ipaddress: ipAddress,
        signerId: aanumber,
        properties: {
          routingNumber,
          accountNumber,
          membershipFee: amt
        }
      }
    }).then((res) => {
      console.info("The process was successful");
    });
  };

  handleGetPaymentIntent = async (paymentMethod) => {
    const {
      getPaymentIntent,
      token,
      aanumber,
      stripeCustomerId,
      lambdaAPIKey,
      personObj
    } = this.state;
    const url = getPaymentIntent;
    const headers = {
      "x-api-key": lambdaAPIKey
    };

    await this.setState({ loading: true });

    await axios(url, {
      method: "POST",
      headers,
      data: {
        token,
        aaId: aanumber,
        customerId: stripeCustomerId,
        payer: personObj
      }
    })
      .then((response) => {
        this.makePaymentRequest(response.data.client_secret, paymentMethod);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  makePaymentRequest = async (clientSecret, paymentMethod) => {
    const { stripe } = this.props;
    // Confirm the PaymentIntent without handling potential next actions (yet).
    stripe
      .confirmCardPayment(
        clientSecret,
        { payment_method: paymentMethod },
        { handleActions: false }
      )
      .then((confirmResult) => {
        if (confirmResult.error) {
          console.error("the request failed to process.");
          this.setState({ alertMessage: "There was an issue processing your payment" });
        } else {
          this.setState({ alertMessage: "Your payment was processed" });
        }
      });
    await this.setState({ loading: false, show: true });
  };

  handleOnSuccess = async (token, metadata) => {
    const { account_id } = metadata;
    const {
      lambdaAPIKey,
      plaidApiUrl,
      aanumber,
      stripeCustomerId,
      personObj,
      invoiceTotal
    } = this.state;

    this.setState({ loading: true, processing: true, bankChecked: false });

    const headers = {
      "x-api-key": lambdaAPIKey
    };

    await axios(plaidApiUrl, {
      method: "POST",
      headers,
      data: {
        token,
        account_id,
        aaId: aanumber,
        amount: parseInt(invoiceTotal.replace('.', ''), 10),
        customerId: stripeCustomerId,
        payer: personObj
      }
    })
      .then((res) => {
        if (res.status === 200) {
          this.handleCreateAuthLetter(
            res.data.routing_number,
            res.data.account_number,
            invoiceTotal
          );
          this.setState({
            show: true,
            confirmationNumber: res.data.id,
            alertMessage: "Your payment was processed"
          });
        } else {
          this.setState({
            show: true,
            confirmationNumber: "",
            alertMessage: "There was an issue processing your payment"
          });
        }
      })
      .catch((e) => {
        console.error("there was an error: ", e);
        console.error(e);
        this.setState({
          show: true,
          confirmationNumber: "",
          alertMessage: "There was an issue processing your payment"
        });
      });

    this.setState({
      loading: false,
      processing: false,
      enablePaymentButton: false
    });
  };

  handleOnExit = () => {
    this.setState({
      enablePaymentButton: false,
      show: true,
      alertMessage: "You have cancelled your transaction"
    });
  };

  handleOpenPlaid = () => {
    this.setState({ openPlaidInterface: true, processing: true });
  };

  handleCheckItem = (obj) => {
    const { checked } = this.state;
    if (!checked.includes(obj.aaid)) {
      this.setState(
        {
          checked: [...checked, obj.aaid]
        },
        () => this.handleDisableButton(checked.length)
      );
    } else {
      this.setState(
        {
          checked: checked.filter((val) => val !== obj.aaid)
        },
        () => this.handleDisableButton(checked.length)
      );
    }
  };

  override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

  handleClose = () => {
    const { show, alertMessage } = this.state;
    this.setState({ show: !show, name: "" });
    if (
      (alertMessage && alertMessage.includes("Your payment was processed")) ||
      (alertMessage &&
        alertMessage.includes("You have cancelled your transaction"))
    ) {
      window.history.replaceState({}, document.title, "/");
      window.location.reload();
    }
  };

  handleOnEnter = async (e) => {
    const { aanumber } = this.state;
    this.setState({ loading: true });
    if (e.keyCode === 13) {
      await this.handleMemberNumberLookup(aanumber);
      await this.handleGetCustomerStripeId(aanumber);
    }
    this.setState({ loading: false });
  };

  handleSettingUpPaymentRequest = async () => {
    const { stripe } = this.props;
    const { invoiceTotal } = this.state;

    if (invoiceTotal > 0) {
      const paymentRequest = await stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: "AutoTec Payment Intent",
          amount: invoiceTotal
        }
      });

      setTimeout(() => {
        paymentRequest.on("paymentmethod", async (ev) => {
          await this.handleGetPaymentIntent(ev.paymentMethod.id);
          ev.complete("success");
        });
      }, 250);

      await paymentRequest.canMakePayment().then((result) => {
        if (result) {
          this.setState({ paymentRequest, applePayment: result.applePay });
        } else {
          console.error("There was an error processing this request");
        }
      });
    }
  };

  handleEnablePaymentButton = () => {
    const {
      aanumber,
      name,
      cardChecked,
      processing,
      zipCodeValid,
      creditCardEntered,
      formValid
    } = this.state;
    if (
      aanumber.length === 9
      && name
      && cardChecked
      && !processing
      && zipCodeValid
      && creditCardEntered
      && formValid
    ) {
      this.setState({ enablePaymentButton: false });
    } else {
      this.setState({ enablePaymentButton: true });
    }
  };

  render() {
    console.log('this state: ', this.state);
    const { customerState, invoiceTotal, taxCalculated, salesTaxPercentage, salesTax, membershipRate, ...items } = this.state;
    return (
      <div style={items.loading ? { pointerEvents: 'none', backgroundColor: '#F5F4F4', opacity: 0.7 } : {}}>
        <div
          style={{ backgroundColor: "#000", height: "50px", width: "100%" }}
        />
        <SimpleModal
          show={items.show}
          handleClose={this.handleClose}
          alertSize={items.alertSize}
        >
          <div style={{ textAlign: "center" }}>
            {items.confirmationNumber && (
              <img
                style={{ width: "60px" }}
                src={PaymentSuccess}
                alt="Payment Successful"
              />
            )}
          </div>
          <p style={{ textAlign: "center" }}>
            {items.alertMessage}
            {(items.alertMessage.includes("email") ||
              items.alertMessage.includes("electrónico")) &&
              items.alertMessage2 && (
                <a href="https://auctionaccess.com">auctionaccess.com </a>
              )}
            {(items.alertMessage.includes("email") ||
              items.alertMessage.includes("electrónico")) &&
              items.alertMessage2
              ? items.alertMessage2
              : ""}
          </p>
          <br />
          {items.confirmationNumber && (
            <p style={{ textAlign: "center" }}>
              Transaction Id:
              {items.confirmationNumber}
            </p>
          )}
        </SimpleModal>
        <img src={aaBlue} alt="Auction Access" className="blue-image" />
        <button
          type="button"
          className="cancel-button"
          onClick={this.handleCancelledPayment}
        >
          {items.stripeCancelButton}
        </button>
        <div className="container">
          <div className="row">
            <div className="offset-sm-10 offset-xs-12 move-item-right padding-to-section">
              <a
                href="#"
                className={
                  items.selectedLanguage === "english"
                    ? "language-link-hide"
                    : "language-link"
                }
                onClick={() => this.changeText("english")}
              >
                In English
              </a>
              <a
                href="#"
                className={
                  items.selectedLanguage === "spanish"
                    ? "language-link-hide"
                    : "language-link"
                }
                onClick={() => this.changeText("spanish")}
              >
                En Español
              </a>
              <a
                href="#"
                className={
                  items.selectedLanguage === "french"
                    ? "language-link-hide"
                    : "language-link"
                }
                onClick={() => this.changeText("french")}
              >
                En Français
              </a>
            </div>
          </div>
        </div>
        <div className="bg-image">
          <div className="container" style={{ paddingTop: "50px" }}>
            <div className="row">
              <div className="offset-md-5">
                <div className="panel panel-default" />
              </div>
            </div>
          </div>
          <Container>
            <Row>
              <Col className="move-left">
                <p style={{ fontSize: "1.5rem" }}>{items.searchMessage}</p>
              </Col>
            </Row>
            <Row className="member-data-section">
              <Col lg={{ span: 6 }} xs={12}>
                <div className="aa-position-image">
                  <p className="border-text-l">Your information</p>
                  <div style={{ border: "1px solid #C3C3C3", padding: "5%", position: "relative" }}>
                    <div className="search-items">
                      <span style={{ fontSize: "17px", margin: "auto 0" }}>
                        {items.aaID}
                        &nbsp;&nbsp;
                      </span>
                      <input
                        className="input-group my-1 p-1 border search-input"
                        value={items.aanumber}
                        name="aanumber"
                        placeholder="1XXXXXXXX"
                        onChange={(e) => this.handleStateChange(e)}
                        onClick={(e) => this.handleClearFields(e)}
                        onKeyDown={(e) => this.handleOnEnter(e)}
                      />
                      <button
                        style={
                          items.aanumber.length === 9 && !items.loading
                            ? { background: "#1C407B" }
                            : { background: "#ddd" }
                        }
                        className="search-button"
                        disabled={items.aanumber.length !== 9 || items.loading}
                        onClick={this.handleMemberLookup}
                      >
                        {items.searchButton}
                      </button>
                    </div>
                    <span>
                      {items.aanumber &&
                        items.aanumber.length === 9 &&
                        (
                          <MemberInfo
                            name={items.name}
                            fromDate={items.fromDate}
                            to={items.to}
                            labelNameOnCard={items.labelNameOnCard}
                            lastNameEndsWith={items.lastNameEndsWith}
                            membershipFeeAmt={items.membershipFeeAmt}
                            invoiceNumber={items.invoiceNumber}
                            invoiceNumberValue={items.invoiceNumberValue}
                            through={items.through}
                            membershipPeriod={items.membershipPeriod}
                          />
                        )}
                    </span>
                  </div>
                </div>
              </Col>
              <Col lg={{ span: 6 }} xs={12}>
                <div className="group-box-section">
                  <p className="border-text-r">Amount Due</p>
                  <div className="amt-due-group">
                    <table style={{ width: "100%" }}>
                      <tbody style={{ padding: "0", margin: "0" }}>
                        <tr>
                          <th className="th-left">{membershipRate}</th>
                          <th style={{ paddingLeft: "8%" }}>{salesTax}</th>
                          <th style={{ paddingLeft: "5%" }}>Total</th>
                        </tr>
                        <tr>
                          <td>${items.uiBaseAmount}/year</td>
                          <td style={{ textAlign: "center" }}>${parseFloat(taxCalculated) > 0 ? taxCalculated : '0.00'}
                            ({salesTaxPercentage ? `${customerState} ${salesTaxPercentage}`
                              : `${parseFloat(0.0).toFixed(1)}%`})</td>
                          <td style={{ textAlign: "center" }}>${invoiceTotal}</td>
                        </tr>
                      </tbody>
                    </table>
                    <hr />
                    <div className="total-amt">
                      {/* <div className="total-amt-item-group"> */}
                      <div className="total-amt-item-group">
                        <div className="total-amt-item">TOTAL</div>
                        <div className="total-amt-item">${invoiceTotal}</div>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6} className="move-left mbr-fee-message">
                {items.selectedLanguage === "english" && <FAQEnglish amount={items.uiBaseAmount} />}
                {items.selectedLanguage === "spanish" && <FAQSpanish amount={items.uiBaseAmount} />}
                {items.selectedLanguage === "french" && <FAQFrench amount={items.uiBaseAmount} />}
              </Col>
              <Col lg={6}>
                <main className="container">
                  <form
                    className="form-group mt-3 p-3 needs-validation"
                    onSubmit={(e) => this.handleSubmit(e)}
                  >
                    <div className="form-group">
                      {items.customerData.length > 1 && (
                        <div style={{ marginBottom: "15px" }}>
                          {items.checked.length}
                          &nbsp; memberships @ ${items.uiBaseAmount} = $
                          {items.checked.length * parseInt(items.uiBaseAmount)}
                          USD
                        </div>
                      )}
                      <div style={{ marginTop: "35px" }} />
                      <div className="payment-option-group">
                        <div
                          className={
                            Object.keys(items.paymentRequest).length > 0
                              ? "checkbox-align"
                              : "checkbox-align-without-buttons"
                          }
                        >
                          <div className="checkbox">
                            <label
                              className="form-check-label"
                              htmlFor="checkPayWithCard"
                            >
                              <span>{items.radioPayWithCard}</span>
                            </label>
                            <input
                              type="checkbox"
                              className="form-check-input pull-right"
                              id="checkPayWithCard"
                              name="checkPayWithCard"
                              checked={items.cardChecked}
                              onChange={e => this.handleCheckClicked(e)}
                            />
                          </div>
                          <div className="checkbox">
                            <label
                              className="form-check-label"
                              htmlFor="checkPayWithBank"
                            >
                              <span>{items.radioPayWithACH}</span>
                            </label>
                            <input
                              type="checkbox"
                              className="form-check-input pull-right"
                              id="checkPayWithBank"
                              name="checkPayWithBank"
                              checked={items.bankChecked}
                              onChange={(e) => this.handleCheckClicked(e)}
                            />
                          </div>
                        </div>
                        <div className="checkbox-align-buttons">
                          {Object.keys(items.paymentRequest).length > 0
                            && items.applePayment
                            ? (
                              <a
                                href="#"
                                disabled={Object.keys(items.personObj).length === 0}
                                style={Object.keys(items.personObj).length > 0 ? { cursor: 'pointer' } : { cursor: 'initial' }}
                                onClick={() => Object.keys(items.personObj).length > 0 && items.paymentRequest.show()}
                              >
                                <img
                                  src={applePay}
                                  style={Object.keys(items.personObj).length > 0 ? { cursor: 'pointer' } : { cursor: 'initial' }}
                                  alt="apple pay"
                                />
                              </a>

                            ) : (<div>&nbsp;</div>)}
                          {Object.keys(items.paymentRequest).length > 0
                            && !items.applePayment
                            && (
                              <a
                                href="#"
                                disabled={Object.keys(items.personObj).length === 0}
                                style={Object.keys(items.personObj).length > 0 ? { cursor: 'pointer' } : { cursor: 'initial' }}
                                onClick={() => Object.keys(items.personObj).length > 0 && items.paymentRequest.show()}
                              >
                                <img
                                  src={googlePay}
                                  alt="google pay"
                                  style={Object.keys(items.personObj).length > 0 ? { cursor: 'pointer' } : { cursor: 'initial' }}
                                />
                              </a>
                            )}
                        </div>
                      </div>
                    </div>
                    {items.loading && (
                      <div
                        style={{
                          position: "fixed",
                          top: "50%",
                          left: "50%",
                          zIndex: "2",
                          transform: "translate(-50%, -50%)"
                        }}
                      >
                        <SyncLoader
                          className="loader"
                          sizeUnit="px"
                          size={25}
                          color="#013D7D"
                          loading={items.loading}
                        />
                      </div>
                    )}
                    {items.cardChecked && items.refresh ? (
                      <PayWithCard
                        handleStateChange={this.handleStateChange}
                        handleMemberLookup={this.handleMemberLookup}
                        handleCreditCardEntered={this.handleCreditCardEntered}
                        handleInvalidFields={this.handleInvalidFields}
                        {...this.state}
                      />
                    ) : (
                      <div />
                    )}
                    {items.bankChecked && items.refresh ? (
                      <PayWithBank
                        handleStateChange={this.handleStateChange}
                        handleMemberLookup={this.handleMemberLookup}
                        validateChecked={this.validateChecked}
                        handleInvalidFields={this.handleInvalidFields}
                        handleAchCheckChange={this.handleAchCheckChange}
                        {...this.state}
                      />
                    ) : (
                      <div />
                    )}
                    {items.aanumber.length === 9 &&
                      items.name &&
                      items.bankChecked &&
                      !items.memberNotFound &&
                      items.formErrors.achChecked.length === 0 &&
                      items.formValid &&
                      items.achChecked ? (
                      <PlaidLink
                        style={{ backgroundColor: "#1C407B" }}
                        clientName="AuctionACCESS"
                        env={items.plaidEnvironment}
                        product={["auth", "transactions"]}
                        publicKey={items.plaidApiKey}
                        onExit={this.handleOnExit}
                        onSuccess={this.handleOnSuccess}
                      >
                        Pay
                      </PlaidLink>
                    ) : (
                      <button
                        disabled={items.enablePaymentButton || !items.validated}
                        className={
                          items.enablePaymentButton || !items.validated
                            ? "btn-disabled"
                            : "btn-enabled"
                        }
                      >
                        {items.paymentButton}
                      </button>
                    )}
                  </form>
                </main>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  data: {
    language: state.getLanguage
  }
});

const ConnectedForm = connect(mapStateToProps)(Form);

export default injectStripe(ConnectedForm);
